  <form nz-form *ngIf="mainformGroup && fieldNew && controlExists" [formGroup]="mainformGroup" [nzLayout]="'vertical'">
    <nz-form-item *ngIf="!field.hidden" [ngStyle]="field.noFormItemMarginBottom?{'margin-bottom':'0'}:{}">
        <nz-form-label [nzFor]="fieldNew" *ngIf="!field.noLabel" [nzRequired]="field.required">{{field.label|translateTA}}</nz-form-label>
        <nz-form-control  [nzValidatingTip]="field.tooltip" nzHasFeedback>
            <nz-input-group [nzSuffix]="inputClearTpl" [nzPrefix]="formulaTpl"  nzSearch [nzAddOnAfter]="field.action!=null?suffixIconButton:''">
                <input #inputValue nz-input [formControlName]="fieldNew" [nzAutocomplete]="auto" [placeholder]="field.placeholder|translateTA" [nzSize]="field.size == null? 'default': field.size" [type]="field.isPassword?'password':'text'" [disabled]="field.isDisabled"/>
            </nz-input-group>
             <nz-autocomplete #auto>
                <nz-auto-option *ngFor="let option of filteredOptionsAutocomplete" [nzValue]="option">
                    {{ option }}
                </nz-auto-option>
            </nz-autocomplete>
        </nz-form-control>
    </nz-form-item>
    <ng-template #inputClearTpl>
        @if (mainformGroup.get(fieldNew)?.value) {
            <nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="mainformGroup.get(fieldNew).setValue(null)" />
        }
    </ng-template>
    <ng-template #formulaTpl>
        @if (field.showFormula) {
            <nz-icon nzType="thunderbolt" (click)="openFormula()"/>
        }
    </ng-template>
    <ng-template #suffixIconButton>
        @if (field.action){
            <button nz-button nzType="primary" nzSearch (click)="openComponentAction($event, field.action)" >
                <nz-icon [nzType]="field.action.icon" />
            </button>
        }
      
    </ng-template>
</form>